import WithErrorHandling, { RequestError } from 'src/components/hoc/withErrorHandling';
import { hideWriteCTA } from 'src/constants/restrictedCommunities';
import { fetchPostForEdit, showPollPage } from 'src/modules/community/write/actions';
import { fetchCurrentCommunity } from 'src/modules/shared/context/actions';
import WritePage from 'src/modules/community/write/writePage';
import { PageContext, Permission, Role } from 'src/constants/types';
import { userHasPermission, userHasRole } from 'src/utils/context';
const Page = () => <WritePage data-sentry-element="WritePage" data-sentry-component="Page" data-sentry-source-file="write.tsx" />;
Page.getInitialProps = async ({
  store: {
    getState,
    dispatch
  },
  query: {
    communitySlug,
    id
  }
}: PageContext) => {
  if (!getState().context.currentUser) {
    throw new RequestError('This page is not available to visitors', 401);
  }

  // checking if the page is a community write page, or community select > write page
  if (communitySlug) {
    await dispatch(fetchCurrentCommunity(communitySlug));
    const {
      currentCommunity,
      communityErrorStatusCode,
      currentUser
    } = getState().context;
    if (!currentCommunity) {
      const isHiddenPrivateCommunity = communityErrorStatusCode === 310;
      if (isHiddenPrivateCommunity) {
        throw new RequestError('This is a private community', 404); // user is not a member
      }
      throw new RequestError('Error fetching community', communityErrorStatusCode);
    }
    if (hideWriteCTA.includes(communitySlug) && !userHasRole(currentUser, Role.HealthUnlocked) || currentCommunity.isArchived) {
      throw new RequestError('This is a read-only community', 404);
    }
    await dispatch(showPollPage(false));
    if (id) {
      // Edit post
      await dispatch(fetchPostForEdit(id, communitySlug));
      const {
        post,
        postError
      } = getState().pages.write;
      if (postError || !post?.id) throw new RequestError('Error fetching post', postError?.status || 500);
      const isActionAllowed = currentUser?.userId === post.author.id || userHasPermission(currentUser, Permission.EditPost);
      if (!isActionAllowed) throw new RequestError('Permission denied', 404); // user does not have permission to edit
    }
  }
  return {};
};
export default WithErrorHandling(Page);